/*
 * File: user-header-info.ts
 * Created: 2025-12-08 21:05:26
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-09 10:02:01
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component, Emit } from "vue-property-decorator";
import { BaseComponent } from "@root/components";
import { UIQuick } from "@root/core/utilities/quick-helper";
import { ProjectView } from "@/views/project-view";

@Component
export default class UserHeaderInfo extends BaseComponent {
    /// define
    quick = this.quicks().User;

    @Emit("enableChanged")
    doEnableChanged(value) {
        return value;
    }

    static quicks = UIQuick.getInstanceMap();
    quicks() {
        return ProjectView.quicks;
    }
}
